<template lang="pug">
  .user-tile
    .user
      avatar(:user="user" :size="120" trigger="click")
      .username {{ user.fullname || "Someone" }}
      a.instagram(:href="user.instagram ? `https://instagram.com/${user.instagram}` : '#'" target="_blank") {{ user.instagram ? `@${user.instagram}` : "-" }}
    follow-button(:user="user")

</template>

<script>
// Components
import FollowButton from "@/components/FollowButton";
import UserInfo from "@/components/feed/UserInfo";
import Avatar from "@/components/Avatar";

export default {
  name: "UserTile",
  components: {
    FollowButton,
    UserInfo,
    Avatar
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      cdnURL: process.env.VUE_APP_CDN_URL
    };
  }
};
</script>

<style lang="stylus">
.user-tile {
  border-radius();
  border: $color-light-border 1px solid;
  padding-bottom: 20px;
  position: relative;
  text-align: center;

  .actions {
    pinned-tr(absolute, 10px);

    .more-action {
      border-radius();
      padding: 9px 15px;

      &:hover {
        cursor: pointer;
        background-color: $color-lightest-grey;
      }
    }
  }

  .user {
    margin-bottom: 15px;
    text-align: center;

    .avatar {
      animate();
      background-image();
      border-radius(50%);
      background-color: $color-lightest-grey;
      border: $color-light-border 1px solid;
      margin: 15px auto;
      height: 120px;
      width: 120px;

      &:hover {
        cursor: pointer;
        transform: scale(1.1);
      }
    }

    .username {
      font-weight: bold;
      line-height: 20px;
    }

    .count {
      color: $color-text-subheading;
      font-size: 0.8em;
      line-height: 20px;
    }

    a.instagram {
      color: $color-info;
      text-decoration: none;
    }
  }

  .posts {
    .post {
      background-image();
      background-color: $color-lightest-grey;
      position: relative;
      max-width: 40%;
      height: 200px;
      width: 100%;
    }

    .caption {
      padding: 20px;
      text-align: center;

      .text {
      }

      .timestamp {
        color: $color-text-subheading;
        font-size: 0.8em;
        margin-top: 5px;
      }
    }
  }
}
</style>
